"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var EditIcon = function EditIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333F48' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.162 2.23815L2.23815 13.162C2.08566 13.3145 2 13.5213 2 13.737V17.1869C2 17.636 2.36403 18 2.81309 18H6.26303C6.47868 18 6.68549 17.9143 6.83798 17.7619L17.7619 6.83798C18.0794 6.52044 18.0794 6.00562 17.7619 5.68809L14.3119 2.23815C13.9944 1.92062 13.4796 1.92062 13.162 2.23815ZM13.7362 3.96224L16.0365 6.26247L14.3183 7.98066L12.018 5.68043L13.7362 3.96224ZM10.8681 6.83031L3.62543 14.073V16.3733H5.92567L13.1684 9.13055L10.8681 6.83031Z",
    fill: color
  }));
};

var _default = EditIcon;
exports.default = _default;